/** MVC Account/SignIn is on the API host, not under /api (see AccountController Route). */
export function getAccountSignInUrl(): string {
  const raw = ((import.meta as any).env?.VITE_API_URL as string | undefined)?.trim() ?? '';
  if (raw.startsWith('http://') || raw.startsWith('https://')) {
    try {
      return `${new URL(raw).origin}/Account/SignIn`;
    } catch {
      /* fall through */
    }
  }
  if (typeof window !== 'undefined') {
    return `${window.location.origin}/Account/SignIn`;
  }
  return '/Account/SignIn';
}

/** Avoid redirect loop: login route and MVC Account before session / Autheris tokens exist. */
export function shouldDeferAutherisBrowserRedirect(): boolean {
  if (typeof window === 'undefined') return false;
  const path = window.location.pathname.toLowerCase();
  if (path.startsWith('/account/')) return true;
  if (path === '/login') return true;
  const hash = window.location.hash.toLowerCase();
  if (/^#\/login([/?#]|$)/.test(hash)) return true;
  return false;
}
